import { render, staticRenderFns } from "./AdminStockPlansPanel.vue?vue&type=template&id=778fb90c&scoped=true"
import script from "./AdminStockPlansPanel.vue?vue&type=script&lang=js"
export * from "./AdminStockPlansPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminStockPlansPanel.vue?vue&type=style&index=0&id=778fb90c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778fb90c",
  null
  
)

export default component.exports